import { SearchResultItem } from "./M365PulseSearchBox.types";
import { createContext } from "react";
import { makeAutoObservable } from "mobx";

export const SearchStore = (initValue: string) => () => {
    const store: {
        keyword: string;
        open: boolean;
        searchResultList: SearchResultItem[];
        inputRef: HTMLInputElement | null;
        setOpen(value: boolean): void;
        setInputRef(ref: HTMLInputElement | null): void;
        onClearKeyword(): void;
        setKeyword(word: string): void;
        returnFocusToInput(): void;
        getEnhancedSearchResults(): Array<SearchResultItem & { onClick: () => void }>;
        getSearchResultMap(): Map<string, SearchResultItem[]>;
    } = {
        keyword: initValue,
        open: false,
        searchResultList: new Array<SearchResultItem>(),
        inputRef: null,

        setOpen(value: boolean) {
            this.open = value;
        },

        setInputRef(ref: HTMLInputElement | null) {
            this.inputRef = ref;
        },

        onClearKeyword() {
            this.keyword = "";
        },

        setKeyword(word: string) {
            this.keyword = word;
        },

        returnFocusToInput() {
            if (this.inputRef) {
                this.inputRef.focus();
            }
        },

        getEnhancedSearchResults() {
            return this.searchResultList.map((item) => ({
                ...item,
                onClick: () => {
                    if (item.onClick) {
                        item.onClick();
                    }
                    this.onClearKeyword();
                    this.setOpen(false);
                }
            }));
        },

        getSearchResultMap() {
            return this.getEnhancedSearchResults().reduce((result, item) => {
                const category = item.category || "";
                result.set(category, [...(result.get(category) || []), item]);
                return result;
            }, new Map<string, SearchResultItem[]>());
        }
    };

    makeAutoObservable(store);
    return store;
};

export type ISearchStore = ReturnType<ReturnType<typeof SearchStore>>;
export const SearchContext = createContext<ISearchStore | undefined>(undefined);
